import React from "react";
import "../../Styles/HomeComponentsStyles/PremiumPitch.css";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import EmailIcon from "@mui/icons-material/Email";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ListIcon from "@mui/icons-material/List";
import DownloadIcon from "@mui/icons-material/Download";
import StarIcon from "@mui/icons-material/Star";
import LightModeIcon from "@mui/icons-material/LightMode";

import {
  Box,
  createTheme,
  Stack,
  ThemeProvider,
  Avatar,
  Typography,
  Button,
} from "@mui/material";

const PremiumPitch = () => {
  return (
    <div className="earning__page">
      <div className="earnings__portion__wrapper"></div>
      <Box sx={{ padding: "90px 90px" }} className="earnings__portion">
        <Box>
          <Typography
            sx={{
              fontSize: "16px",
              fontFamily: "Lexend",
              color: "#09e08d",
              fontWeight: "400",
              marginBottom: "8px",
            }}
          >
            InvestCharts Premium
          </Typography>
          <Typography
            sx={{
              color: "#fcfcfc",
              fontFamily: "Lexend",
              fontSize: "43px",
              fontWeight: "600",
              color: "#3b84f6",
              color: "#fcfcfc",
            }}
          >
            Better insights mean smarter decision
          </Typography>
          <Typography
            sx={{
              fontSize: "18px",
              fontFamily: "public sans",
              color: "#c8c8c8",
              marginTop: "10px",
            }}
          >
            Get earnings results by email. Sync earnings calendar. Compare
            metrics. Download data. And more!
          </Typography>
        </Box>
        <Box
          sx={{
            padding: "30px 0",
            marginTop: "40px",
          }}
        >
          <Box
            sx={{
              fontFamily: "public sans",
              color: "#b0b0b0",
              fontSize: "18px",
            }}
          >
            <Typography
              sx={{
                fontSize: "24px",
                fontFamily: "Lexend",
                color: "#09e08d",
                fontWeight: "400",
                marginBottom: "8px",
                fontWeight: "600",
              }}
            >
              Premium Features
            </Typography>
            <Typography
              sx={{
                fontSize: "18px",
                fontFamily: "public sans",
                color: "#c8c8c8",
                marginTop: "10px",
              }}
            >
              Hypercharts Premium include following exclusive features:
            </Typography>
            <Box
              sx={{
                marginTop: "30px",
                fontFamily: "public sans",
                color: "#c8c8c8",
                display: "grid",
                gridTemplateColumns: "40% 40%",
                gap: " 20px 20%",
              }}
            >
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "7px" }}
              >
                <CompareArrowsIcon
                  sx={{ color: "#09e08d", fontSize: "36px" }}
                />
                <Box
                  sx={{
                    fontWeight: "16px",
                    color: "#fcfcfc",
                    fontFamily: "Lexend",
                  }}
                >
                  Compare Financials
                </Box>
                <Box sx={{ fontWeight: "14px" }}>
                  Compare any financial metric of multiple companies over time.
                </Box>
              </Box>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "7px" }}
              >
                <ShowChartIcon sx={{ color: "#09e08d", fontSize: "36px" }} />
                <Box
                  sx={{
                    fontWeight: "16px",
                    color: "#fcfcfc",
                    fontFamily: "Lexend",
                  }}
                >
                  Historical Stock Price Charts
                </Box>
                <Box sx={{ fontWeight: "14px" }}>
                  Unlock access to historical stock price charts for period
                  longer than one month.
                </Box>
              </Box>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "7px" }}
              >
                <EmailIcon sx={{ color: "#09e08d", fontSize: "36px" }} />
                <Box
                  sx={{
                    fontWeight: "16px",
                    color: "#fcfcfc",
                    fontFamily: "Lexend",
                  }}
                >
                  Receive Earnings Results by Email
                </Box>
                <Box sx={{ fontWeight: "14px" }}>
                  Receive the latest quarterly financials charts of your
                  favorite companies directly in your inbox soon after they are
                  released.
                </Box>
              </Box>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "7px" }}
              >
                <CalendarMonthIcon
                  sx={{ color: "#09e08d", fontSize: "36px" }}
                />
                <Box
                  sx={{
                    fontWeight: "16px",
                    color: "#fcfcfc",
                    fontFamily: "Lexend",
                  }}
                >
                  Sync Earnings Calendar
                </Box>
                <Box sx={{ fontWeight: "14px" }}>
                  Sync the earnings calendar of your favorite companies or all
                  companies to your device.
                </Box>
              </Box>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "7px" }}
              >
                <ListIcon sx={{ color: "#09e08d", fontSize: "36px" }} />
                <Box
                  sx={{
                    fontWeight: "16px",
                    color: "#fcfcfc",
                    fontFamily: "Lexend",
                  }}
                >
                  Toggle between Chart and Data view
                </Box>
                <Box sx={{ fontWeight: "14px" }}>
                  View the underlying data for any financial chart.
                </Box>
              </Box>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "7px" }}
              >
                <DownloadIcon sx={{ color: "#09e08d", fontSize: "36px" }} />
                <Box
                  sx={{
                    fontWeight: "16px",
                    color: "#fcfcfc",
                    fontFamily: "Lexend",
                  }}
                >
                  Download Chart and Company data
                </Box>
                <Box sx={{ fontWeight: "14px" }}>
                  Download all financials data for a company or a specific set
                  of data of a single chart.
                </Box>
              </Box>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "7px" }}
              >
                <StarIcon sx={{ color: "#09e08d", fontSize: "36px" }} />
                <Box
                  sx={{
                    fontWeight: "16px",
                    color: "#fcfcfc",
                    fontFamily: "Lexend",
                  }}
                >
                  Track your favorite companies
                </Box>
                <Box sx={{ fontWeight: "14px" }}>
                  Get improved visibility and navigation to your favorite
                  companies.
                </Box>
              </Box>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "7px" }}
              >
                <LightModeIcon sx={{ color: "#09e08d", fontSize: "36px" }} />
                <Box
                  sx={{
                    fontWeight: "16px",
                    color: "#fcfcfc",
                    fontFamily: "Lexend",
                  }}
                >
                  Dark Theme
                </Box>
                <Box sx={{ fontWeight: "14px" }}>In all its glory!</Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            marginTop: "50px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            style={{
              background: "transparent",
              color: "white",
              padding: "6px 20px",
              fontSize: "18px",
              fontFamily: "public sans",
              //   borderRadius: "20px",
              cursor: "pointer",
              outline: "none",
              border: "none",
              borderBottom: "1px solid #09e08d ",
              color: "#09e08d",
              // textDecoration: "underline",
            }}
          >
            Start your 14 days free trial
          </button>
        </Box>
      </Box>
    </div>
  );
};

export default PremiumPitch;
